<template>
    <div>
        <v-checkbox v-model="booking.isCCar" label="Courtesy Car?" />
        <v-checkbox v-if="booking.isCCar" v-model="booking.ccTypeManual" label="Manual" />
        <v-checkbox v-if="booking.isCCar" v-model="booking.ccTypeAuto" label="Automatic" />
    </div>
</template>

<script>
    export default {
        name: "RsCourtesyCar",
        props: {
            booking: Object
        }
    }
</script>

<style scoped>

</style>
